import { lazy } from "react";

import CareIcon from "@/CAREUI/icons/CareIcon";

import { PluginManifest } from "@/pluginTypes";

const TeleconsultFacilityPage = lazy(() => import("./TeleconsultFacilityPage"));

// Wording: public/locale/<lang>.json, loaded by CARE as this plugin's i18n
// namespace (served at /local-plugins/myhis-teleconsult/locale/).
// Every screen talks to the myhis_teleconsult plug only, and shows one
// "not enabled" state while its TELECONSULT_ENABLED flag is off.
const manifest: PluginManifest = {
  plugin: "myhis-teleconsult",
  routes: {
    // The facility's teleconsult desk: today's sessions, the user's own tele
    // profile here, and the facility's setup (managers).
    "/facility/:facilityId/teleconsult": ({ facilityId }) => (
      <TeleconsultFacilityPage facilityId={facilityId} />
    ),
  },
  components: {
    FacilityHomeActions: lazy(() => import("./TeleDeskButton")),
  },
  // The desk in the facility's left navigation, beside Patients and
  // Appointments (CARE prefixes the url with /facility/<id>/). The label is
  // static here: CARE reads it before the plugin's locale namespace loads.
  navItems: [
    {
      name: "Teleconsultation",
      url: "teleconsult",
      icon: <CareIcon icon="l-video" />,
    },
  ],
  encounterTabs: {
    // The remote session on this visit's appointment.
    teleconsult: lazy(() => import("./EncounterTeleTab")),
  },
};

export default manifest;
